import React from "react";

function XMarkIcon(props) {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-xmark"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-xmark"
      viewBox="0 0 20 20"
      width={_width}
      {...props}
    >
      <path
        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z"
        opacity="1"
      ></path>
    </svg>
  );
}
export default XMarkIcon;
